import { ranking } from '../libs/api';

export const companiesTOP = (form) => async dispatch => {
  await ranking.companies('COMPANIESTOP', dispatch);
};

export const subsectorsTOP = (form) => async dispatch => {
  await ranking.subsectors('SUBSECTORSTOP', dispatch);
};
